// Données des diagnostics - VERSION COMPLÈTE (Excel-conforme)
(function() {
  'use strict';

  window.DIAGNOSTIC_DATA = {
    "DIAG DIGESTION": {
      "name": "Digestion & Transit",
      "icon": "🌱",
      "description": "Ballonnements, constipation, digestion lourde",
      "questions": [
        {
          "id": "Q1_DIG",
          "label": "Quel est votre principal inconfort digestif ?",
          "options": [
            { "id": "1a", "label": "Ballonnements / ventre gonflé", "next": "Q2_BALL" },
            { "id": "2a", "label": "Constipation / transit lent", "next": "Q2_CONST" },
            { "id": "3a", "label": "Digestion lourde après les repas / foie fatigué", "next": "Q2_DIGEST" },
            { "id": "4a", "label": "Digestion fragile / microbiote perturbé (après antibiotiques, stress…)", "next": "Q2_MICR" }
          ]
        },
        {
          "id": "Q2_BALL",
          "label": "À quelle fréquence avez-vous des ballonnements ?",
          "condition": "Q1_DIG=1a",
          "options": [
            { "id": "1b", "label": "Tous les jours", "next": "Q3_DIG" },
            { "id": "2b", "label": "Plusieurs fois par semaine", "next": "Q3_DIG" },
            { "id": "3b", "label": "Rarement (surtout après des excès)", "next": "Q3_DIG" }
          ]
        },
        {
          "id": "Q2_CONST",
          "label": "Depuis combien de temps votre transit est-il ralenti ?",
          "condition": "Q1_DIG=2a",
          "options": [
            { "id": "1c", "label": "Moins de 2 semaines", "next": "Q3_DIG" },
            { "id": "2c", "label": "Plus de 2 semaines", "next": "Q3_DIG" },
            { "id": "3c", "label": "Depuis plusieurs mois / années", "next": "Q3_DIG" }
          ]
        },
        {
          "id": "Q2_DIGEST",
          "label": "Vos inconforts sont-ils surtout liés à des repas copieux ou excès alimentaires ?",
          "condition": "Q1_DIG=3a",
          "options": [
            { "id": "1d", "label": "Oui, surtout après excès", "next": "Q3_DIG" },
            { "id": "2d", "label": "Oui, mais aussi en dehors des excès", "next": "Q3_DIG" },
            { "id": "3d", "label": "Non, c'est plutôt permanent", "next": "Q3_DIG" }
          ]
        },
        {
          "id": "Q2_MICR",
          "label": "Avez-vous récemment pris des antibiotiques ou vécu une période de gros stress ?",
          "condition": "Q1_DIG=4a",
          "options": [
            { "id": "1e", "label": "Oui, antibiotiques", "next": "Q3_DIG" },
            { "id": "2e", "label": "Oui, stress / fatigue intense", "next": "Q3_DIG" },
            { "id": "3e", "label": "Non / je ne sais pas", "next": "Q3_DIG" }
          ]
        },
        {
          "id": "Q3_DIG",
          "label": "Ces inconforts apparaissent-ils plutôt :",
          "options": [
            { "id": "1f", "label": "De façon permanente", "next": "Q4_DIG" },
            { "id": "2f", "label": "Par périodes (après excès, changements de saison, voyages…)", "next": "Q4_DIG" },
            { "id": "3f", "label": "Très occasionnellement", "next": "Q4_DIG" }
          ]
        },
        {
          "id": "Q4_DIG",
          "label": "Quel facteur vous semble le plus lié à vos troubles digestifs ?",
          "options": [
            { "id": "1g", "label": "Stress / fatigue", "next": "Q5_BALL" },
            { "id": "2g", "label": "Alimentation riche / irrégulière", "next": "Q5_BALL" },
            { "id": "3g", "label": "Manque d'activité physique", "next": "Q5_BALL" },
            { "id": "4g", "label": "Aucun facteur évident", "next": "Q5_BALL" }
          ]
        },
        {
          "id": "Q5_BALL",
          "label": "Votre priorité est plutôt de :",
          "condition": "Q1_DIG=1a",
          "options": [
            { "id": "1h", "label": "Diminuer les ballonnements au quotidien", "next": "RESULTS" },
            { "id": "2h", "label": "Alléger la digestion après les repas", "next": "RESULTS" },
            { "id": "3h", "label": "Travailler sur la flore intestinale", "next": "RESULTS" }
          ]
        },
        {
          "id": "Q5_CONST",
          "label": "Votre priorité est plutôt de :",
          "condition": "Q1_DIG=2a",
          "options": [
            { "id": "1i", "label": "Relancer rapidement le transit", "next": "RESULTS" },
            { "id": "2i", "label": "Stabiliser un transit régulier", "next": "RESULTS" },
            { "id": "3i", "label": "Agir à la fois sur transit + flore intestinale", "next": "RESULTS" }
          ]
        },
        {
          "id": "Q5_DIGEST",
          "label": "Votre priorité est plutôt de :",
          "condition": "Q1_DIG=3a",
          "options": [
            { "id": "1j", "label": "Soulager après les repas lourds", "next": "RESULTS" },
            { "id": "2j", "label": "Faire une cure detox / drainage", "next": "RESULTS" },
            { "id": "3j", "label": "Améliorer le confort digestif global", "next": "RESULTS" }
          ]
        },
        {
          "id": "Q5_MICR",
          "label": "Votre priorité est plutôt de :",
          "condition": "Q1_DIG=4a",
          "options": [
            { "id": "1k", "label": "Rééquilibrer la flore après antibiotiques", "next": "RESULTS" },
            { "id": "2k", "label": "Apaiser les sensibilités digestives", "next": "RESULTS" },
            { "id": "3k", "label": "Prévenir les inconforts à long terme", "next": "RESULTS" }
          ]
        }
      ]
    },

    "DIAG VITALITÉ": {
      "name": "Vitalité & Fatigue",
      "icon": "⚡",
      "description": "Énergie, tonus, immunité",
      "questions": [
        {
          "id": "Q1_VIT",
          "label": "Quels signes observez-vous ?",
          "options": [
            { "id": "1a", "label": "Fatigue physique (manque d'énergie, corps « vidé »)", "next": "Q2_VIT" },
            { "id": "2a", "label": "Fatigue mentale / concentration difficile (brouillard mental)", "next": "Q2_VIT" },
            { "id": "3a", "label": "Fatigue liée au manque de récupération (sommeil non réparateur)", "next": "Q2_VIT" },
            { "id": "4a", "label": "Fatigue persistante malgré repos et bonne hygiène de vie", "next": "Q2_VIT" }
          ]
        },
        {
          "id": "Q2_VIT",
          "label": "Dans quel contexte ressentez-vous cette fatigue ?",
          "options": [
            { "id": "1b", "label": "Période de stress / surcharge (travail, charge mentale, examens…)", "next": "Q3_VIT" },
            { "id": "2b", "label": "Rythme intense / manque de temps pour bien manger ou faire du sport", "next": "Q3_VIT" },
            { "id": "3b", "label": "Convalescence, post-infection ou coup de pompe après l'hiver", "next": "Q3_VIT" },
            { "id": "4b", "label": "Aucun contexte particulier, cette fatigue revient souvent", "next": "Q3_VIT" }
          ]
        },
        {
          "id": "Q3_VIT",
          "label": "Votre sommeil en ce moment :",
          "options": [
            { "id": "1c", "label": "Je dors mal (difficultés d'endormissement, réveils nocturnes)", "next": "Q4_VIT" },
            { "id": "2c", "label": "Je dors assez mais je ne me sens pas reposé(e)", "next": "Q4_VIT" },
            { "id": "3c", "label": "Mon sommeil est plutôt correct", "next": "Q4_VIT" }
          ]
        },
        {
          "id": "Q4_VIT",
          "label": "Quels autres signes remarquez-vous en plus de la fatigue ?",
          "options": [
            { "id": "1d", "label": "Essoufflement à l'effort, teint pâle, chute de cheveux accrue", "next": "Q5_VIT" },
            { "id": "2d", "label": "Sensation de jambes lourdes / circulation difficile", "next": "Q5_VIT" },
            { "id": "3d", "label": "Irritabilité, sautes d'humeur, nervosité", "next": "Q5_VIT" },
            { "id": "4d", "label": "Moral en baisse, perte de motivation, tristesse", "next": "Q5_VIT" },
            { "id": "5d", "label": "Aucun de ces symptômes", "next": "Q5_VIT" }
          ]
        },
        {
          "id": "Q5_VIT",
          "label": "Quel est votre objectif principal ?",
          "options": [
            { "id": "1e", "label": "Retrouver un coup de boost rapide dans la journée", "next": "Q6_VIT" },
            { "id": "2e", "label": "Retrouver une énergie stable et durable au quotidien", "next": "Q6_VIT" },
            { "id": "3e", "label": "Mieux récupérer la nuit et me réveiller plus reposé(e)", "next": "Q6_VIT" }
          ]
        },
        {
          "id": "Q6_VIT",
          "label": "Votre mode de vie actuel :",
          "options": [
            { "id": "1f", "label": "Alimentation plutôt déséquilibrée / irrégulière", "next": "RESULTS" },
            { "id": "2f", "label": "Alimentation correcte mais journées très chargées", "next": "RESULTS" },
            { "id": "3f", "label": "Alimentation saine et équilibrée", "next": "RESULTS" }
          ]
        }
      ]
    },

    "DIAG STRESS": {
      "name": "Stress & Sommeil",
      "icon": "🧘",
      "description": "Gestion du stress, sommeil, humeur",
      "questions": [
        {
          "id": "Q1_STR",
          "label": "Quels signes observez-vous ?",
          "options": [
            { "id": "1a", "label": "Stress, nervosité, charge mentale difficile à gérer", "next": "Q2_STR" },
            { "id": "2a", "label": "Sommeil difficile (endormissement, réveils, sommeil agité)", "next": "Q2_STR" },
            { "id": "3a", "label": "Moral en baisse, tristesse, perte de motivation", "next": "Q2_STR" },
            { "id": "4a", "label": "Toutes ces réponses à la fois", "next": "Q2_STR" }
          ]
        },
        {
          "id": "Q2_STR",
          "label": "Depuis combien de temps ressentez-vous ces symptômes ?",
          "options": [
            { "id": "1b", "label": "Moins de 2 semaines", "next": "Q3_STR" },
            { "id": "2b", "label": "Plus de 2 semaines", "next": "Q3_STR" },
            { "id": "3b", "label": "Plusieurs mois / années", "next": "Q3_STR" }
          ]
        },
        {
          "id": "Q3_STR",
          "label": "Comment décririez-vous votre stress dans la journée ?",
          "options": [
            { "id": "1c", "label": "Je me sens souvent tendu(e), irrité(e) ou à fleur de peau", "next": "Q4_STR" },
            { "id": "2c", "label": "Je me sens submergé(e) / surmené(e) (trop de choses en tête)", "next": "Q4_STR" },
            { "id": "3c", "label": "Je gère plutôt bien mon stress dans la journée", "next": "Q4_STR" }
          ]
        },
        {
          "id": "Q4_STR",
          "label": "Votre sommeil ces derniers temps :",
          "options": [
            { "id": "1d", "label": "J'ai du mal à m'endormir", "next": "Q5_STR" },
            { "id": "2d", "label": "Je me réveille souvent la nuit / sommeil agité", "next": "Q5_STR" },
            { "id": "3d", "label": "Je dors assez mais je ne me sens pas reposé(e)", "next": "Q5_STR" },
            { "id": "4d", "label": "Mon sommeil est correct", "next": "Q5_STR" }
          ]
        },
        {
          "id": "Q5_STR",
          "label": "Votre humeur et votre motivation :",
          "options": [
            { "id": "1e", "label": "Moral en baisse, perte d'envies / d'intérêt", "next": "Q6_STR" },
            { "id": "2e", "label": "Tristesse, rumination, anxiété légère", "next": "Q6_STR" },
            { "id": "3e", "label": "Manque de confiance, fatigue morale / mentale", "next": "Q6_STR" },
            { "id": "4e", "label": "Mon humeur est plutôt stable", "next": "Q6_STR" }
          ]
        },
        {
          "id": "Q6_STR",
          "label": "Signes associés :",
          "options": [
            { "id": "1f", "label": "Tensions musculaires, crampes, palpitations, fourmillements", "next": "Q7_STR" },
            { "id": "2f", "label": "Difficultés de concentration, brouillard mental, trous de mémoire", "next": "Q7_STR" },
            { "id": "3f", "label": "Fatigue physique importante en plus du stress", "next": "Q7_STR" },
            { "id": "4f", "label": "Aucun de ces symptômes", "next": "Q7_STR" }
          ]
        },
        {
          "id": "Q7_STR",
          "label": "Dans quel contexte vous reconnaissez-vous le plus ?",
          "options": [
            { "id": "1g", "label": "Période de surcharge professionnelle ou personnelle (travail, examens, charge mentale)", "next": "Q8_STR" },
            { "id": "2g", "label": "Cette situation revient souvent chez moi, même hors période particulière", "next": "Q8_STR" }
          ]
        },
        {
          "id": "Q8_STR",
          "label": "Vos priorités :",
          "options": [
            { "id": "1h", "label": "M'apaiser dans la journée et mieux gérer mon stress", "next": "RESULTS" },
            { "id": "2h", "label": "Retrouver un sommeil plus profond et réparateur", "next": "RESULTS" },
            { "id": "3h", "label": "Retrouver une humeur positive et plus de motivation", "next": "RESULTS" },
            { "id": "4h", "label": "Toutes ces réponses à la fois", "next": "RESULTS" }
          ]
        }
      ]
    },

    "DIAG MINCEUR": {
      "name": "Minceur & Silhouette",
      "icon": "💪",
      "description": "Perte de poids, cellulite, rétention d'eau",
      "questions": [
        {
          "id": "Q1_MIN",
          "label": "Quel est votre objectif principal ?",
          "options": [
            { "id": "1a", "label": "Perdre du poids de façon globale", "next": "Q2_MIN" },
            { "id": "2a", "label": "Affiner certaines zones (ventre, hanches, cuisses, fessiers)", "next": "Q2_MIN" },
            { "id": "3a", "label": "Réduire la cellulite / l'aspect peau d'orange", "next": "Q2_MIN" },
            { "id": "4a", "label": "Diminuer la rétention d'eau et les gonflements", "next": "Q2_MIN" },
            { "id": "5a", "label": "Mieux contrôler les envies de sucre / grignotages", "next": "Q2_MIN" }
          ]
        },
        {
          "id": "Q2_MIN",
          "label": "Depuis combien de temps cette problématique est-elle présente ?",
          "options": [
            { "id": "1b", "label": "Moins de 3 mois", "next": "Q3_MIN" },
            { "id": "2b", "label": "Entre 3 mois et 1 an", "next": "Q3_MIN" },
            { "id": "3b", "label": "Depuis plus d'un an", "next": "Q3_MIN" }
          ]
        },
        {
          "id": "Q3_MIN",
          "label": "La zone qui vous gêne le plus :",
          "options": [
            { "id": "1c", "label": "Surtout le ventre / tour de taille", "next": "Q4_MIN" },
            { "id": "2c", "label": "Surtout hanches, cuisses, fessiers", "next": "Q4_MIN" },
            { "id": "3c", "label": "Un peu partout de façon diffuse", "next": "Q4_MIN" }
          ]
        },
        {
          "id": "Q4_MIN",
          "label": "Comment décririez-vous votre situation actuelle ?",
          "options": [
            { "id": "1d", "label": "J'ai pris du poids récemment (stress, changements, vacances, grossesse…)", "next": "Q5_MIN" },
            { "id": "2d", "label": "Je fais attention, mais mon poids stagne", "next": "Q5_MIN" },
            { "id": "3d", "label": "Je reprends du poids facilement après chaque régime", "next": "Q5_MIN" },
            { "id": "4d", "label": "Je suis surtout gêné(e) par ballonnements / ventre gonflé", "next": "Q5_MIN" }
          ]
        },
        {
          "id": "Q5_MIN",
          "label": "Vos habitudes alimentaires :",
          "options": [
            { "id": "1e", "label": "Grignotage fréquent / envies de sucre", "next": "Q6_MIN" },
            { "id": "2e", "label": "Repas copieux, riches en graisses ou en féculents", "next": "Q6_MIN" },
            { "id": "3e", "label": "Alimentation plutôt équilibrée, mais quantités difficiles à ajuster", "next": "Q6_MIN" }
          ]
        },
        {
          "id": "Q6_MIN",
          "label": "Rétention d'eau et circulation :",
          "options": [
            { "id": "1f", "label": "Jambes lourdes, chevilles qui gonflent, sensation d'eau dans les tissus", "next": "Q7_MIN" },
            { "id": "2f", "label": "Gonflements localisés (ventre, bas du corps) surtout en fin de journée", "next": "Q7_MIN" },
            { "id": "3f", "label": "Peu ou pas de rétention d'eau", "next": "Q7_MIN" }
          ]
        },
        {
          "id": "Q7_MIN",
          "label": "Cellulite / aspect de la peau :",
          "options": [
            { "id": "1g", "label": "Cellulite visible au repos (cuisses, fesses, hanches)", "next": "Q8_MIN" },
            { "id": "2g", "label": "Peau d'orange visible surtout en lumière / en contraction", "next": "Q8_MIN" },
            { "id": "3g", "label": "Peu ou pas de cellulite gênante", "next": "Q8_MIN" }
          ]
        },
        {
          "id": "Q8_MIN",
          "label": "Votre niveau d'activité physique :",
          "options": [
            { "id": "1h", "label": "Très peu actif/active (sédentaire, peu de sport)", "next": "Q9_MIN" },
            { "id": "2h", "label": "Actif/active modéré(e) (marche, quelques séances/semaine)", "next": "Q9_MIN" },
            { "id": "3h", "label": "Très actif/active (sport régulier, intensif)", "next": "Q9_MIN" }
          ]
        },
        {
          "id": "Q9_MIN",
          "label": "Vos priorités pour cette cure :",
          "options": [
            { "id": "1i", "label": "Un démarrage efficace (phase « attaque » sur 1 mois)", "next": "RESULTS" },
            { "id": "2i", "label": "Un travail de fond progressif et durable", "next": "RESULTS" },
            { "id": "3i", "label": "Une aide surtout sur le contrôle alimentaire (satiété, sucre, grignotages)", "next": "RESULTS" }
          ]
        }
      ]
    },

    "DIAG PEAU": {
      "name": "Peau & Cheveux",
      "icon": "✨",
      "description": "Cheveux, ongles, éclat de peau",
      "questions": [
        {
          "id": "Q1_PCH",
          "label": "Quelle est votre problématique principale ?",
          "options": [
            { "id": "1a", "label": "Chute de cheveux (diffuse ou par périodes)", "next": "Q2_PCH" },
            { "id": "2a", "label": "Cheveux fragiles, cassants, ternes", "next": "Q2_PCH" },
            { "id": "3a", "label": "Problèmes de peau (sécheresse, teint terne, imperfections légères)", "next": "Q2_PCH" },
            { "id": "4a", "label": "Ongles cassants, mous, qui se dédoublent", "next": "Q2_PCH" },
            { "id": "5a", "label": "Un peu tout à la fois (cheveux, peau, ongles)", "next": "Q2_PCH" }
          ]
        },
        {
          "id": "Q2_PCH",
          "label": "Depuis combien de temps cette problématique est-elle présente ?",
          "options": [
            { "id": "1b", "label": "Moins de 3 mois", "next": "Q3_PCH" },
            { "id": "2b", "label": "Entre 3 et 12 mois", "next": "Q3_PCH" },
            { "id": "3b", "label": "Depuis plus d'un an", "next": "Q3_PCH" }
          ]
        },
        {
          "id": "Q3_PCH",
          "label": "À propos de vos cheveux :",
          "options": [
            { "id": "1c", "label": "Chute importante, cheveux qui tombent par poignées", "next": "Q4_PCH" },
            { "id": "2c", "label": "Chute modérée mais qui dure dans le temps", "next": "Q4_PCH" },
            { "id": "3c", "label": "Cheveux qui se cassent facilement, fourches, manque de densité", "next": "Q4_PCH" },
            { "id": "4c", "label": "Cheveux qui ne poussent pas ou très peu / stagnent", "next": "Q4_PCH" }
          ]
        },
        {
          "id": "Q4_PCH",
          "label": "À propos de votre peau :",
          "options": [
            { "id": "1d", "label": "Peau sèche, inconfort, tiraillements", "next": "Q5_PCH" },
            { "id": "2d", "label": "Peau terne, manque d'éclat, teint fatigué", "next": "Q5_PCH" },
            { "id": "3d", "label": "Petites imperfections récurrentes (boutons, irrégularités)", "next": "Q5_PCH" },
            { "id": "4d", "label": "Ma peau ne me pose pas de souci particulier", "next": "Q5_PCH" }
          ]
        },
        {
          "id": "Q5_PCH",
          "label": "Vos ongles :",
          "options": [
            { "id": "1e", "label": "Ongles qui cassent facilement", "next": "Q6_PCH" },
            { "id": "2e", "label": "Ongles mous / qui se dédoublent", "next": "Q6_PCH" },
            { "id": "3e", "label": "Pas de problème particulier avec mes ongles", "next": "Q6_PCH" }
          ]
        },
        {
          "id": "Q6_PCH",
          "label": "Contexte et facteurs possibles :",
          "options": [
            { "id": "1f", "label": "Période de stress ou de fatigue importante ces derniers temps", "next": "Q7_PCH" },
            { "id": "2f", "label": "Changement hormonal (post-partum, arrêt pilule, ménopause…)", "next": "Q7_PCH" },
            { "id": "3f", "label": "Perte de poids / régime / alimentation moins équilibrée", "next": "Q7_PCH" },
            { "id": "4f", "label": "Aucun facteur particulier identifié", "next": "Q7_PCH" }
          ]
        },
        {
          "id": "Q7_PCH",
          "label": "Votre alimentation et hygiène de vie :",
          "options": [
            { "id": "1g", "label": "Alimentation plutôt déséquilibrée / peu de fruits et légumes", "next": "Q8_PCH" },
            { "id": "2g", "label": "Alimentation plutôt saine et variée", "next": "Q8_PCH" }
          ]
        },
        {
          "id": "Q8_PCH",
          "label": "Votre objectif principal est de :",
          "options": [
            { "id": "1h", "label": "Stopper la chute et renforcer la pousse des cheveux", "next": "RESULTS" },
            { "id": "2h", "label": "Améliorer l'aspect et la brillance des cheveux", "next": "RESULTS" },
            { "id": "3h", "label": "Retrouver une peau plus belle et lumineuse", "next": "RESULTS" },
            { "id": "4h", "label": "Renforcer cheveux + ongles en même temps", "next": "RESULTS" }
          ]
        }
      ]
    },

    "DIAG CIRCULATION": {
      "name": "Circulation & Articulations",
      "icon": "🦵",
      "description": "Jambes lourdes, articulations, souplesse",
      "questions": [
        {
          "id": "Q1_CIR",
          "label": "Quelle est votre problématique principale ?",
          "options": [
            { "id": "1a", "label": "Jambes lourdes, gonflées, avec parfois des impatiences", "next": "Q2_CIR" },
            { "id": "2a", "label": "Douleurs ou raideurs articulaires (genoux, hanches, mains, dos…)", "next": "Q2_CIR" },
            { "id": "3a", "label": "Un peu les deux (circulation + articulations)", "next": "Q2_CIR" }
          ]
        },
        {
          "id": "Q2_CIR",
          "label": "Depuis combien de temps cette problématique est-elle présente ?",
          "options": [
            { "id": "1b", "label": "Moins de 3 mois", "next": "Q3_CIR" },
            { "id": "2b", "label": "Entre 3 et 12 mois", "next": "Q3_CIR" },
            { "id": "3b", "label": "Depuis plus d'un an", "next": "Q3_CIR" }
          ]
        },
        {
          "id": "Q3_CIR",
          "label": "Concernant vos jambes et votre circulation :",
          "options": [
            { "id": "1c", "label": "Sensation de jambes lourdes en fin de journée", "next": "Q4_CIR" },
            { "id": "2c", "label": "Jambes qui gonflent (chevilles, mollets)", "next": "Q4_CIR" },
            { "id": "3c", "label": "Veines apparentes, inconfort veineux (fourmillements, impatiences)", "next": "Q4_CIR" },
            { "id": "4c", "label": "Je ne suis pas particulièrement gêné(e) par mes jambes", "next": "Q4_CIR" }
          ]
        },
        {
          "id": "Q4_CIR",
          "label": "Dans quelles situations vos jambes vous gênent-elles le plus ?",
          "options": [
            { "id": "1d", "label": "En fin de journée, surtout si je reste longtemps debout", "next": "Q5_CIR" },
            { "id": "2d", "label": "Lors de voyages prolongés (avion, voiture)", "next": "Q5_CIR" },
            { "id": "3d", "label": "Quasi en permanence", "next": "Q5_CIR" }
          ]
        },
        {
          "id": "Q5_CIR",
          "label": "Concernant vos articulations :",
          "options": [
            { "id": "1e", "label": "Raideurs au réveil ou après immobilité (se dérouiller le matin)", "next": "Q6_CIR" },
            { "id": "2e", "label": "Douleurs à l'effort ou après une journée active", "next": "Q6_CIR" },
            { "id": "3e", "label": "Gênes quasi permanentes qui limitent certains gestes", "next": "Q6_CIR" },
            { "id": "4e", "label": "Pas de gêne articulaire particulière", "next": "Q6_CIR" }
          ]
        },
        {
          "id": "Q6_CIR",
          "label": "Quelles zones sont les plus concernées ?",
          "options": [
            { "id": "1f", "label": "Genoux et/ou hanches", "next": "Q7_CIR" },
            { "id": "2f", "label": "Dos (lombaires, cervicales)", "next": "Q7_CIR" },
            { "id": "3f", "label": "Mains, poignets, doigts", "next": "Q7_CIR" },
            { "id": "4f", "label": "Plusieurs zones à la fois", "next": "Q7_CIR" }
          ]
        },
        {
          "id": "Q7_CIR",
          "label": "Votre activité physique :",
          "options": [
            { "id": "1g", "label": "Plutôt sédentaire (assis(e) ou debout longtemps, peu de marche)", "next": "Q8_CIR" },
            { "id": "2g", "label": "Actif/active modéré(e) (marche, quelques séances de sport)", "next": "Q8_CIR" },
            { "id": "3g", "label": "Très actif/active ou sportif(ve)", "next": "Q8_CIR" }
          ]
        },
        {
          "id": "Q8_CIR",
          "label": "Avez-vous déjà eu un diagnostic médical sur ces problèmes ?",
          "options": [
            { "id": "1h", "label": "Oui, pour un problème veineux (varices, insuffisance veineuse…)", "next": "Q9_CIR" },
            { "id": "2h", "label": "Oui, pour un problème articulaire (arthrose, tendinite, autre)", "next": "Q9_CIR" },
            { "id": "3h", "label": "Non, jamais", "next": "Q9_CIR" },
            { "id": "4h", "label": "Je ne sais pas / je n'ai pas fait de bilan", "next": "Q9_CIR" }
          ]
        },
        {
          "id": "Q9_CIR",
          "label": "Votre objectif prioritaire avec cette cure :",
          "options": [
            { "id": "1j", "label": "Alléger mes jambes et diminuer la sensation de lourdeur/gonflement", "next": "RESULTS" },
            { "id": "2j", "label": "Retrouver davantage de souplesse et de confort dans mes articulations", "next": "RESULTS" },
            { "id": "3j", "label": "Agir à la fois sur circulation et articulations", "next": "RESULTS" }
          ]
        }
      ]
    }
  };

  // PRODUCT_INFO - produits publiés + nouveaux produits Excel
  window.PRODUCT_INFO = {
    "Probiotiques 10 milliards": {
      name: "Probiotiques 10 milliards - 30 gélules",
      description: "10 milliards de souches actives",
      benefits: ["Équilibre digestif", "Immunité", "Après antibiotiques"],
      shopifyHandle: "probiotiques-10-milliards"
    },
    "Probiotiques 3 milliards": {
      name: "Probiotiques 3 milliards - 15 Gélules",
      description: "Formule douce pour entretien quotidien",
      benefits: ["Confort digestif", "Usage quotidien", "Flore intestinale"],
      shopifyHandle: "probiotiques-3-milliards-15-gelules"
    },
    "Transit": {
      name: "Transit - 30 gélules",
      description: "Régule et relance le transit",
      benefits: ["Transit", "Régularité", "Confort intestinal"],
      shopifyHandle: "transit"
    },
    "Draineur universel": {
      name: "Draineur universel - 15 sticks + 15 gélules",
      description: "Programme détox 15 jours",
      benefits: ["Détox", "Drainage", "Élimination"],
      shopifyHandle: "draineur-universel"
    },
    "Detox": {
      name: "Detox - 45 gélules",
      description: "Régénère le foie",
      benefits: ["Soutien hépatique", "Digestion", "Purification"],
      shopifyHandle: "detox"
    },
    "Énergie+": {
      name: "Énergie+ - 30 Gélules",
      description: "Cocktail vitaminé",
      benefits: ["Boost énergie", "Anti-fatigue", "Concentration"],
      shopifyHandle: "energie"
    },
    "Vitamine D Végétale": {
      name: "Vitamine D Végétale - 30 Gélules",
      description: "D3 végétale",
      benefits: ["Immunité", "Os solides", "Moral"],
      shopifyHandle: "theralica-vitamine-d-vegetale-30-gelules"
    },
    "Stress Jour": {
      name: "Stress Jour - 30 Gélules",
      description: "Adaptogène naturel",
      benefits: ["Anti-stress", "Calme", "Équilibre"],
      shopifyHandle: "stress-jour-30-gelules"
    },
    "Stress nuit sommeil": {
      name: "Stress nuit sommeil - 30 gélules",
      description: "Sommeil réparateur",
      benefits: ["Endormissement", "Sommeil profond", "Récupération"],
      shopifyHandle: "stress-nuit-sommeil-30-gelules"
    },
    "Chrome CR Cannelle": {
      name: "Chrome CR Cannelle - 30 Gélules",
      description: "Équilibre l'appétit",
      benefits: ["Glycémie", "Réduit fringales", "Métabolisme"],
      shopifyHandle: "theralica-chrome-cr-cannelle-30-gelules"
    },
    "Minceur Cellulite": {
      name: "Minceur Cellulite - 30 Gélules",
      description: "Anti-cellulite",
      benefits: ["Lisse la peau", "Anti-capitons", "Drainage"],
      shopifyHandle: "minceur-cellulite-30-gelules"
    },
    "Minceur Contrôle": {
      name: "Minceur Contrôle - 60 Gélules",
      description: "Contrôle du poids",
      benefits: ["Poids", "Satiété", "Métabolisme"],
      shopifyHandle: "minceur-controle-60-gelules"
    },
    "Minceur Ventre Plat": {
      name: "Minceur Ventre Plat",
      description: "Ventre plat et digestion légère",
      benefits: ["Ventre plat", "Ballonnements", "Digestion"],
      shopifyHandle: "minceur-ventre-plat"
    },
    "Acide Hyaluronique RE": {
      name: "Acide Hyaluronique RE-PULP - 15 Gélules",
      description: "270mg repulpant",
      benefits: ["Hydrate", "Repulpe", "Anti-âge"],
      shopifyHandle: "acide-hyaluronique-re-pulp-15-gelules"
    },
    "Cheveux Anti": {
      name: "Cheveux Anti-chute - 90 Gélules",
      description: "Programme 3 mois",
      benefits: ["Anti-chute", "Fortifie", "Densité"],
      shopifyHandle: "cheveux-anti-chute-90-gelules"
    },
    "Cheveux & Ongles Croissance": {
      name: "Cheveux & Ongles Croissance - 60 Gélules",
      description: "Active la croissance",
      benefits: ["Pousse", "Ongles solides", "Brillance"],
      shopifyHandle: "cheveux-ongles-croissance-60-gelules"
    },
    "Peau Nette Perfecteur": {
      name: "Peau Nette Perfecteur - 30 Gélules",
      description: "Nettoie de l'intérieur",
      benefits: ["Purifie", "Imperfections", "Éclat"],
      shopifyHandle: "peau-nette-perfecteur-30-gelules"
    },
    "Peau Sèche Nutrition": {
      name: "Peau Sèche Nutrition - 60 capsules",
      description: "Huiles précieuses",
      benefits: ["Nourrit", "Hydratation", "Confort"],
      shopifyHandle: "peau-seche-nutrition-60-capsules"
    },
    "Antioxydant": {
      name: "Antioxydant - 30 Gélules",
      description: "Bouclier antioxydant",
      benefits: ["Anti-âge", "Protège", "Éclat"],
      shopifyHandle: "antioxydant-30-gelules"
    },
    "Zinc Immunité Peau et Cheveux": {
      name: "Zinc - 30 Gélules",
      description: "Zinc bisglycinate",
      benefits: ["Peau saine", "Cheveux", "Immunité"],
      shopifyHandle: "theralica-zinc-immunite-peau-et-cheveux-30-gelules"
    },
    "Vitamine C liposomale": {
      name: "Vitamine C liposomale - 30 gélules",
      description: "Haute absorption + Q10",
      benefits: ["Immunité", "Anti-oxydant", "Énergie"],
      shopifyHandle: "vitamine-c-liposomale-30-gelules"
    },
    "Oméga 3 Microalgue": {
      name: "Oméga 3 Microalgue - 30 gélules",
      description: "DHA végétal",
      benefits: ["Cœur", "Cerveau", "Vision"],
      shopifyHandle: "omega-3-microalgue-30-gelules"
    },
    "Multi": {
      name: "Multi-Vitamines - 45 Gélules",
      description: "Formule complète",
      benefits: ["Vitalité", "Vitamines", "Minéraux"],
      shopifyHandle: "multi-vitamines"
    },
    "Immunité": {
      name: "Immunité - 15 Gélules",
      description: "Défenses naturelles",
      benefits: ["Immunité", "Protection", "Résistance"],
      shopifyHandle: "immunite"
    },
    "Solaire Hydratant Anti": {
      name: "Solaire Hydratant Anti-âge - 60 Gélules",
      description: "Protection solaire",
      benefits: ["Prépare au soleil", "Bronze", "Anti-âge"],
      shopifyHandle: "solaire-hydratant-anti-age-60-gelules"
    }
  };

  console.log('✅ DIAGNOSTIC_DATA chargé:', Object.keys(window.DIAGNOSTIC_DATA).length, 'diagnostics');
  console.log('✅ PRODUCT_INFO chargé:', Object.keys(window.PRODUCT_INFO).length, 'produits');

})();
